import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ToastComponent } from './toast.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule
  ],
  declarations: [ToastComponent],
  exports: [ ToastComponent ]
})
export class ToastModule { }
